unit umain;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,  x.ao,  libloginfo.types,
  WEBLib.Forms, WEBLib.Dialogs,  Vcl.Controls,  weblib.WebSocketClient,x.WebSocket.Shared, x.WebSocket.Client, Vcl.StdCtrls, WEBLib.StdCtrls, VCL.TMSFNCTypes,
  VCL.TMSFNCUtils, VCL.TMSFNCGraphics, VCL.TMSFNCGraphicsTypes, VCL.TMSFNCSplitter, VCL.TMSFNCCustomControl, VCL.TMSFNCTreeViewBase, VCL.TMSFNCTreeViewData,
  VCL.TMSFNCCustomTreeView, VCL.TMSFNCTreeView, VCL.TMSFNCObjectInspector, WEBLib.ExtCtrls, VCL.TMSFNCToolBar, VCL.TMSFNCListBox, VCL.TMSFNCHTMLImageContainer,
  VCL.TMSFNCCheckBox, uwebClientViewer,liblogtest ;

type
  TForm1 = class(TForm)
    WebButton1: TButton;
    pnlTop: TPanel;
    pMain: TPanel;
    WebPanel3: TPanel;
    ix: TTMSFNCObjectInspector;
    WebPanel4: TPanel;
    TMSFNCSplitter1: TTMSFNCSplitter;
    pnlClients: TPanel;
    bActive: TTMSFNCToolBarButton;
    TMSFNCToolBarButton2: TTMSFNCToolBarButton;
    nNewClient: TTMSFNCToolBarButton;
    bc: TTMSFNCToolBarButton;
    cld: TTMSFNCListBox;
    cbAuto: TTMSFNCCheckBox;
    procedure bActiveClick(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure bcBeforeDropDown(Sender: TObject);
    procedure cldItemClick(Sender: TObject; AItem: TTMSFNCListBoxItem);
    procedure ixBeforeOpenObjectEditor(Sender, AObject: TObject; APropertyInfo:
        PPropInfo; APropertyName: string; APropertyType: TTypeKind;
        APropertyValueObject: TObject; var ACanOpen: Boolean);
    procedure nNewClientClick(Sender: TObject);
    procedure TMSFNCToolBarButton2Click(Sender: TObject);
    procedure WebButton1Click(Sender: TObject);
    procedure WebFormShow(Sender: TObject);
  private
    Fclient: txwsClient;
    procedure SetClient(const Value: txwsClient);
    { Private declarations }
  public
   clview: tFormClientList;
      procedure Update(afull: boolean=true);
   procedure ClientEvent(sender: txwsClientBase;amsg:txWSmsg);
    procedure ClientConnected(sender: tobject);
    procedure ClientDisconnected(sender: tobject);
    procedure OtherCLientAdded(ac:  tXWSclient);
    procedure OtherClientRemoved(ac:   tXWSclient);
    property client: txwsClient read Fclient write SetClient;


  protected procedure LoadDFMValues; override; end;

var
  Form1: TForm1;

implementation

{$R *.dfm}

procedure TForm1.bActiveClick(Sender: TObject);
begin
 if client.ReadyState<>1 then client.connect else client.disConnect;

end;

procedure TForm1.WebFormCreate(Sender: TObject);
begin
ix.NodesAppearance.CollapseNodeIcon:=nil;
ix.NodesAppearance.CollapseNodeIconLarge:=nil;

ix.NodesAppearance.ExpandNodeIcon:=nil;
ix.NodesAppearance.ExpandNodeIconLarge:=nil;
end;

procedure TForm1.bcBeforeDropDown(Sender: TObject);
var
 aitem: ttmsfncListBoxItem;
 i: integer;
begin
 if assigned(client) then
 begin
  for i:=1 to cld.Items.Count do
  begin
   aitem:=cld.Items[i-1];
   if aitem.DataObject =client then
   begin
    cld.tag:=1;
    cld.SelectedItem:=aitem;
    cld.tag:=0;
    exit;
   end;

 end;
 end;

end;

procedure TForm1.cldItemClick(Sender: TObject; AItem: TTMSFNCListBoxItem);
begin
 if not assigned(aitem) then exit;
   if cld.tag<>0 then exit;
 client:=txwsclient(aitem.DataObject);
  { ix.&Object:=client;

   clview.Clients:=client.Clients;
   clview.title:='';   }

   bc.CloseDropDown;
end;

procedure TForm1.ClientConnected(sender: tobject);
var
 ac: txwsClient;
begin
   ac:= txwsClient(sender);
  if ac=client then update(true);

end;

procedure TForm1.ClientDisconnected(sender: tobject);
var
 ac: txwsClient;
begin
   ac:= txwsClient(sender);
  if ac=client then update(true);

end;

procedure TForm1.ClientEvent(sender: txwsClientBase; aMsg: txWSMsg);
begin
// console.log('Msg', amsg);
 if sender=client then update(true);
end;

procedure TForm1.ixBeforeOpenObjectEditor(Sender, AObject: TObject;
    APropertyInfo: PPropInfo; APropertyName: string; APropertyType: TTypeKind;
    APropertyValueObject: TObject; var ACanOpen: Boolean);
begin
acanOPen:=false;
end;

procedure TForm1.nNewClientClick(Sender: TObject);
var
 ac: txwsClient;

 aitem: ttmsfncListBoxItem;
begin
cld.BeginUpdate;
 ac:=txwsClient.create;
 ac.EventWatch(@ClientEvent);
 ac.SetValue('name', 'WebBoy ' + inttostr(cld.Items.Count+1));

 ac.onConnected:=ClientConnected;
 ac.onDisConnected:=ClientDisconnected;
 ac.OtherClientAdded:=OtherCLientAdded;
 ac.OtherClientRemoved:=OtherClientRemoved;
 //ix.&Object:=ac;

 aitem:=cld.Items.Add;
 aitem.Text:=ac.getValue('name');
 aitem.DataObject:=ac;

 //cbc.Items.AddObject(ac.getValue('name'), ac);
 cld.EndUpdate;
 //cbc.ItemIndex:=cbc.Items.Count-1;
Client:=ac;
 if cbAuto.Checked then
 begin
 ac.connect;

 end;

end;
procedure TForm1.OtherCLientAdded(ac: tXWSclient);
begin
  Update(true);
end;

procedure TForm1.OtherClientRemoved(ac: tXWSclient);
begin
   Update(true);
end;

procedure TForm1.SetClient(const Value: txwsClient);
begin
  Fclient := Value;
  if value=nil then
  begin
    bc.Text:='<none>';
      pMain.Visible:=false;
    exit;
  end;
    pMain.Visible:=true;
  bc.Text:=value.getValue('name');
  ix.&object:=value;
  // clview.Clients:=client.Clients;
   Update(False);
  // clview.title:='';
end;

procedure TForm1.TMSFNCToolBarButton2Click(Sender: TObject);
begin
Update(true);
 console.log('Client', client);
 alog.send('Connection', client.Connection);
clview.Clients:=client.Clients;
end;

procedure TForm1.Update(afull: boolean);
begin
if assigned(fclient)=false then
 begin

   exit;

 end;


 if fclient.readystate=1 then
 begin
   bActive.Appearance.NormalFill.Color:=gcLightgreen;
    bActive.Appearance.HoverFIll.Color:=gcLightgreen;
     bActive.Appearance.DownFill.Color:=gcLightgreen;
   bActive.Text:='Connected';
 end else
 begin
    bActive.Appearance.NormalFill.Color:=gcCrimson;
     bActive.Appearance.HoverFIll.Color:=gcCrimson;
      bActive.Appearance.DownFill.Color:=gcCrimson;

   bActive.Text:='Not Connected';
 end;
  if afull then
  begin
  ix.RebuildList;
   clview.Clients:=client.Clients;
 //clview.reload;
  end;
end;

procedure TForm1.WebButton1Click(Sender: TObject);
begin
client:=txwsClient.create;
client.EventWatch(@ClientEvent);
client.connect;

end;

procedure TForm1.WebFormShow(Sender: TObject);
procedure FormCreated(AForm: TObject);
  begin
   // SubForm2 := TSubForm2.CreateNew(Page2.ElementID,nil);
   console.log('CLVIEW DONE', clview);
   //  clview.Parent:=pnlClients;
 //  clView.visible:=true;
   //clview.Realign;
   clview.pnlMain.Parent:=pnlClients;
   clview.pnlMain.Realign;
   clview.Hide;
   realign;
  end;

begin
pnlClients.EventStopPropagation:=[];
 clView := tFormClientList.CreateNew(@FormCreated);


 //  client:=nil;
ix.ColumnsAppearance.TopSize:=4;
end;

procedure TForm1.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlTop := TPanel.Create(Self);
  WebButton1 := TButton.Create(Self);
  nNewClient := TTMSFNCToolBarButton.Create(Self);
  cbAuto := TTMSFNCCheckBox.Create(Self);
  bc := TTMSFNCToolBarButton.Create(Self);
  pMain := TPanel.Create(Self);
  WebPanel3 := TPanel.Create(Self);
  ix := TTMSFNCObjectInspector.Create(Self);
  WebPanel4 := TPanel.Create(Self);
  bActive := TTMSFNCToolBarButton.Create(Self);
  TMSFNCToolBarButton2 := TTMSFNCToolBarButton.Create(Self);
  TMSFNCSplitter1 := TTMSFNCSplitter.Create(Self);
  pnlClients := TPanel.Create(Self);
  cld := TTMSFNCListBox.Create(Self);

  pnlTop.BeforeLoadDFMValues;
  WebButton1.BeforeLoadDFMValues;
  nNewClient.BeforeLoadDFMValues;
  cbAuto.BeforeLoadDFMValues;
  bc.BeforeLoadDFMValues;
  pMain.BeforeLoadDFMValues;
  WebPanel3.BeforeLoadDFMValues;
  ix.BeforeLoadDFMValues;
  WebPanel4.BeforeLoadDFMValues;
  bActive.BeforeLoadDFMValues;
  TMSFNCToolBarButton2.BeforeLoadDFMValues;
  TMSFNCSplitter1.BeforeLoadDFMValues;
  pnlClients.BeforeLoadDFMValues;
  cld.BeforeLoadDFMValues;
  try
    Name := 'Form1';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnShow', 'WebFormShow');
    pnlTop.SetParentComponent(Self);
    pnlTop.Name := 'pnlTop';
    pnlTop.Left := 0;
    pnlTop.Top := 0;
    pnlTop.Width := 640;
    pnlTop.Height := 40;
    pnlTop.Margins.Left := 3;
    pnlTop.Margins.Top := 3;
    pnlTop.Margins.Right := 3;
    pnlTop.Margins.Bottom := 3;
    pnlTop.Align := alTop;
    pnlTop.BorderStyle := bsNone;
    pnlTop.ChildOrder := 1;
    WebButton1.SetParentComponent(pnlTop);
    WebButton1.Name := 'WebButton1';
    WebButton1.Left := 344;
    WebButton1.Top := 29;
    WebButton1.Width := 96;
    WebButton1.Height := 25;
    WebButton1.Margins.Left := 3;
    WebButton1.Margins.Top := 3;
    WebButton1.Margins.Right := 3;
    WebButton1.Margins.Bottom := 3;
    WebButton1.Caption := 'WebButton1';
    WebButton1.HeightPercent := 100.000000000000000000;
    WebButton1.WidthPercent := 100.000000000000000000;
    SetEvent(WebButton1, Self, 'OnClick', 'WebButton1Click');
    nNewClient.SetParentComponent(pnlTop);
    nNewClient.Name := 'nNewClient';
    nNewClient.Left := 540;
    nNewClient.Top := 0;
    nNewClient.Width := 100;
    nNewClient.Height := 40;
    nNewClient.Margins.Left := 3;
    nNewClient.Margins.Top := 3;
    nNewClient.Margins.Right := 3;
    nNewClient.Margins.Bottom := 3;
    nNewClient.Align := alRight;
    nNewClient.ParentDoubleBuffered := False;
    nNewClient.DoubleBuffered := True;
    nNewClient.Font.Charset := DEFAULT_CHARSET;
    nNewClient.Font.Color := clWindowText;
    nNewClient.Font.Height := -11;
    nNewClient.Font.Name := 'Segoe UI';
    nNewClient.Font.Style := [];
    nNewClient.ParentColor := True;
    nNewClient.TabOrder := 1;
    SetEvent(nNewClient, Self, 'OnClick', 'nNewClientClick');
    nNewClient.DropDownHeight := 270.000000000000000000;
    nNewClient.DropDownWidth := 270.000000000000000000;
    nNewClient.Text := 'Add';
    nNewClient.BitmapSize := 48.000000000000000000;
    nNewClient.LargeLayoutBitmapSize := 64.000000000000000000;
    nNewClient.Appearance.ShowInnerStroke := False;
    nNewClient.Appearance.Rounding := 0.000000000000000000;
    nNewClient.Appearance.FlatStyle := True;
    nNewClient.ControlIndex := 0;
    cbAuto.SetParentComponent(nNewClient);
    cbAuto.Name := 'cbAuto';
    cbAuto.Left := 3;
    cbAuto.Top := 0;
    cbAuto.Width := 26;
    cbAuto.Height := 22;
    cbAuto.Margins.Left := 3;
    cbAuto.Margins.Top := 3;
    cbAuto.Margins.Right := 3;
    cbAuto.Margins.Bottom := 3;
    cbAuto.ParentDoubleBuffered := False;
    cbAuto.Color := clBtnFace;
    cbAuto.DoubleBuffered := True;
    cbAuto.Font.Charset := DEFAULT_CHARSET;
    cbAuto.Font.Color := clWindowText;
    cbAuto.Font.Height := -11;
    cbAuto.Font.Name := 'Segoe UI';
    cbAuto.Font.Style := [];
    cbAuto.TabOrder := 0;
    cbAuto.Checked := True;
    cbAuto.Text := 'TMSFNCCheckBox';
    bc.SetParentComponent(pnlTop);
    bc.Name := 'bc';
    bc.Left := 0;
    bc.Top := 0;
    bc.Width := 540;
    bc.Height := 40;
    bc.Margins.Left := 3;
    bc.Margins.Top := 3;
    bc.Margins.Right := 3;
    bc.Margins.Bottom := 3;
    bc.Align := alClient;
    bc.ParentDoubleBuffered := False;
    bc.DoubleBuffered := True;
    bc.Font.Charset := DEFAULT_CHARSET;
    bc.Font.Color := clWindowText;
    bc.Font.Height := -16;
    bc.Font.Name := 'Segoe UI';
    bc.Font.Style := [fsBold];
    bc.ParentColor := True;
    bc.TabOrder := 2;
    bc.DropDownAutoWidth := True;
    bc.DropDownKind := ddkDropDown;
    bc.DropDownHeight := 440.000000000000000000;
    bc.DropDownWidth := 400.000000000000000000;
    bc.DropDownControl := cld;
    SetEvent(bc, Self, 'OnBeforeDropDown', 'bcBeforeDropDown');
    bc.Text := 'Selected';
    bc.HorizontalTextAlign := gtaLeading;
    bc.BitmapSize := 48.000000000000000000;
    bc.LargeLayoutBitmapSize := 64.000000000000000000;
    bc.Appearance.ShowInnerStroke := False;
    bc.Appearance.Rounding := 0.000000000000000000;
    bc.Appearance.HoverFill.Kind := gfkNone;
    bc.Appearance.FlatStyle := True;
    bc.ControlIndex := 0;
    pMain.SetParentComponent(Self);
    pMain.Name := 'pMain';
    pMain.Left := 0;
    pMain.Top := 40;
    pMain.Width := 640;
    pMain.Height := 440;
    pMain.Margins.Left := 3;
    pMain.Margins.Top := 3;
    pMain.Margins.Right := 3;
    pMain.Margins.Bottom := 3;
    pMain.Align := alClient;
    pMain.BorderStyle := bsNone;
    pMain.ChildOrder := 1;
    WebPanel3.SetParentComponent(pMain);
    WebPanel3.Name := 'WebPanel3';
    WebPanel3.Left := 0;
    WebPanel3.Top := 0;
    WebPanel3.Width := 288;
    WebPanel3.Height := 440;
    WebPanel3.Margins.Left := 3;
    WebPanel3.Margins.Top := 3;
    WebPanel3.Margins.Right := 3;
    WebPanel3.Margins.Bottom := 3;
    WebPanel3.Align := alLeft;
    WebPanel3.BorderStyle := bsNone;
    WebPanel3.Caption := 'WebPanel3';
    ix.SetParentComponent(WebPanel3);
    ix.Name := 'ix';
    ix.Left := 0;
    ix.Top := 40;
    ix.Width := 288;
    ix.Height := 400;
    ix.Margins.Left := 3;
    ix.Margins.Top := 3;
    ix.Margins.Right := 3;
    ix.Margins.Bottom := 3;
    ix.Align := alClient;
    ix.BevelEdges := [];
    ix.BevelInner := bvNone;
    ix.BevelOuter := bvNone;
    ix.ParentDoubleBuffered := False;
    ix.DoubleBuffered := True;
    ix.TabOrder := 0;
    ix.Stroke.Kind := gskNone;
    ix.Stroke.Color := 11119017;
    ix.GroupsAppearance.TopSize := 100.000000000000000000;
    ix.GroupsAppearance.BottomSize := 100.000000000000000000;
    ix.GroupsAppearance.TopFill.Kind := gfkNone;
    ix.GroupsAppearance.TopFill.ColorTo := 16382457;
    ix.GroupsAppearance.BottomFill.Kind := gfkNone;
    ix.GroupsAppearance.BottomFill.ColorTo := 16382457;
    ix.GroupsAppearance.TopFont.Charset := DEFAULT_CHARSET;
    ix.GroupsAppearance.TopFont.Color := 4539717;
    ix.GroupsAppearance.TopFont.Height := -19;
    ix.GroupsAppearance.TopFont.Name := 'Segoe UI';
    ix.GroupsAppearance.TopFont.Style := [];
    ix.GroupsAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    ix.GroupsAppearance.BottomFont.Color := 4539717;
    ix.GroupsAppearance.BottomFont.Height := -19;
    ix.GroupsAppearance.BottomFont.Name := 'Segoe UI';
    ix.GroupsAppearance.BottomFont.Style := [];
    ix.Columns.Clear;
    with ix.Columns.Add do
    begin
      Name := 'Column0';
      Text := 'Name';
      Width := 200.000000000000000000;
      UseDefaultAppearance := False;
      Fill.Kind := gfkNone;
      Stroke.Kind := gskNone;
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clBlack;
      Font.Height := -14;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      TopFill.Kind := gfkSolid;
      TopStroke.Kind := gskNone;
      TopFont.Charset := DEFAULT_CHARSET;
      TopFont.Color := clWhite;
      TopFont.Height := -22;
      TopFont.Name := 'Segoe UI';
      TopFont.Style := [];
      BottomFont.Charset := DEFAULT_CHARSET;
      BottomFont.Color := clWindowText;
      BottomFont.Height := -22;
      BottomFont.Name := 'Segoe UI';
      BottomFont.Style := [];
      Filtering.DropDownWidth := 200;
      Filtering.DropDownHeight := 240;
      Filtering.ButtonSize := 30.000000000000000000;
    end;
    with ix.Columns.Add do
    begin
      CustomEditor := True;
      Name := 'Column1';
      Text := 'Value';
      Width := 200.000000000000000000;
      UseDefaultAppearance := False;
      Fill.Kind := gfkNone;
      Stroke.Kind := gskNone;
      Font.Charset := DEFAULT_CHARSET;
      Font.Color := clTeal;
      Font.Height := -14;
      Font.Name := 'Segoe UI';
      Font.Style := [];
      TopFill.Kind := gfkSolid;
      TopStroke.Kind := gskNone;
      TopFont.Charset := DEFAULT_CHARSET;
      TopFont.Color := clWhite;
      TopFont.Height := -22;
      TopFont.Name := 'Segoe UI';
      TopFont.Style := [];
      BottomFont.Charset := DEFAULT_CHARSET;
      BottomFont.Color := clWindowText;
      BottomFont.Height := -22;
      BottomFont.Name := 'Segoe UI';
      BottomFont.Style := [];
      Filtering.DropDownWidth := 200;
      Filtering.DropDownHeight := 240;
      Filtering.ButtonSize := 30.000000000000000000;
    end;
    ix.ColumnsAppearance.StretchColumn := 1;
    ix.ColumnsAppearance.StretchAll := False;
    ix.ColumnsAppearance.TopSize := 72.000000000000000000;
    ix.ColumnsAppearance.BottomSize := 50.000000000000000000;
    ix.ColumnsAppearance.TopFont.Charset := DEFAULT_CHARSET;
    ix.ColumnsAppearance.TopFont.Color := 4539717;
    ix.ColumnsAppearance.TopFont.Height := -19;
    ix.ColumnsAppearance.TopFont.Name := 'Segoe UI';
    ix.ColumnsAppearance.TopFont.Style := [fsBold];
    ix.ColumnsAppearance.BottomFont.Charset := DEFAULT_CHARSET;
    ix.ColumnsAppearance.BottomFont.Color := 4539717;
    ix.ColumnsAppearance.BottomFont.Height := -19;
    ix.ColumnsAppearance.BottomFont.Name := 'Segoe UI';
    ix.ColumnsAppearance.BottomFont.Style := [];
    ix.ColumnsAppearance.TopFill.Color := 16380654;
    ix.ColumnsAppearance.TopFill.ColorTo := 16382457;
    ix.ColumnsAppearance.BottomFill.Kind := gfkNone;
    ix.ColumnsAppearance.BottomFill.Color := 16380654;
    ix.ColumnsAppearance.BottomFill.ColorTo := 16382457;
    ix.ColumnsAppearance.TopStroke.Kind := gskNone;
    ix.NodesAppearance.ShowFocus := False;
    ix.NodesAppearance.ExpandWidth := 15.000000000000000000;
    ix.NodesAppearance.ExpandHeight := 15.000000000000000000;
    ix.NodesAppearance.LevelIndent := 2.000000000000000000;
    ix.NodesAppearance.FixedHeight := 25.000000000000000000;
    ix.NodesAppearance.VariableMinimumHeight := 10.000000000000000000;
    ix.NodesAppearance.ShowLines := False;
    ix.NodesAppearance.ColumnStroke.Kind := gskNone;
    ix.NodesAppearance.ColumnStroke.Color := clBlack;
    ix.NodesAppearance.Font.Charset := DEFAULT_CHARSET;
    ix.NodesAppearance.Font.Color := 8026746;
    ix.NodesAppearance.Font.Height := -19;
    ix.NodesAppearance.Font.Name := 'Segoe UI';
    ix.NodesAppearance.Font.Style := [];
    ix.NodesAppearance.TitleFont.Charset := DEFAULT_CHARSET;
    ix.NodesAppearance.TitleFont.Color := clBlack;
    ix.NodesAppearance.TitleFont.Height := -19;
    ix.NodesAppearance.TitleFont.Name := 'Segoe UI';
    ix.NodesAppearance.TitleFont.Style := [];
    ix.NodesAppearance.SelectedFontColor := 4539717;
    ix.NodesAppearance.SelectedTitleFontColor := clBlack;
    ix.NodesAppearance.ExtendedFontColor := 4539717;
    ix.NodesAppearance.SelectedFill.Color := 15128749;
    ix.NodesAppearance.SelectedStroke.Kind := gskNone;
    ix.NodesAppearance.SelectedStroke.Color := 15702829;
    ix.NodesAppearance.SelectedStroke.Width := 4.000000000000000000;
    ix.NodesAppearance.ExtendedStroke.Color := 15987699;
    ix.NodesAppearance.ExtendedFont.Charset := DEFAULT_CHARSET;
    ix.NodesAppearance.ExtendedFont.Color := clWindowText;
    ix.NodesAppearance.ExtendedFont.Height := -19;
    ix.NodesAppearance.ExtendedFont.Name := 'Segoe UI';
    ix.NodesAppearance.ExtendedFont.Style := [];
    ix.NodesAppearance.ExpandNodeIcon.LoadFromFile('umain.WebPanel3.ix.NodesAppearance.ExpandNodeIcon.svg');
    ix.NodesAppearance.CollapseNodeIcon.LoadFromFile('umain.WebPanel3.ix.NodesAppearance.CollapseNodeIcon.svg');
    ix.NodesAppearance.ExpandNodeIconLarge.LoadFromFile('umain.WebPanel3.ix.NodesAppearance.ExpandNodeIconLarge.svg');
    ix.NodesAppearance.CollapseNodeIconLarge.LoadFromFile('umain.WebPanel3.ix.NodesAppearance.CollapseNodeIconLarge.svg');
    ix.Interaction.MouseEditMode := tmemSingleClick;
    ix.Interaction.TouchScrolling := False;
    ix.Interaction.ColumnSizing := True;
    ix.Interaction.ColumnAutoSizeOnDblClick := True;
    ix.Interaction.URLDetectionOnMouseMove := False;
    ix.GlobalFont.Size := 7.000000000000000000;
    ix.GlobalFont.Name := 'Segoe UI';
    ix.DefaultViewJSONOptions.NameHTMLTemplate := '<#NAME>';
    ix.DefaultViewJSONOptions.ValueHTMLTemplate := '<#VALUE>';
    SetEvent(ix, Self, 'OnBeforeOpenObjectEditor', 'ixBeforeOpenObjectEditor');
    WebPanel4.SetParentComponent(WebPanel3);
    WebPanel4.Name := 'WebPanel4';
    WebPanel4.Left := 0;
    WebPanel4.Top := 0;
    WebPanel4.Width := 288;
    WebPanel4.Height := 40;
    WebPanel4.Margins.Left := 3;
    WebPanel4.Margins.Top := 3;
    WebPanel4.Margins.Right := 3;
    WebPanel4.Margins.Bottom := 3;
    WebPanel4.Align := alTop;
    WebPanel4.BorderStyle := bsNone;
    WebPanel4.ChildOrder := 1;
    bActive.SetParentComponent(WebPanel4);
    bActive.Name := 'bActive';
    bActive.AlignWithMargins := True;
    bActive.Left := 6;
    bActive.Top := 6;
    bActive.Width := 100;
    bActive.Height := 28;
    bActive.Margins.Left := 6;
    bActive.Margins.Top := 6;
    bActive.Margins.Right := 6;
    bActive.Margins.Bottom := 6;
    bActive.Align := alLeft;
    bActive.BevelEdges := [];
    bActive.BevelInner := bvNone;
    bActive.BevelOuter := bvNone;
    bActive.ParentDoubleBuffered := False;
    bActive.DoubleBuffered := True;
    bActive.Font.Charset := DEFAULT_CHARSET;
    bActive.Font.Color := clWindowText;
    bActive.Font.Height := -12;
    bActive.Font.Name := 'Segoe UI';
    bActive.Font.Style := [];
    bActive.ParentColor := True;
    bActive.TabOrder := 0;
    SetEvent(bActive, Self, 'OnClick', 'bActiveClick');
    bActive.DropDownHeight := 270.000000000000000000;
    bActive.DropDownWidth := 270.000000000000000000;
    bActive.Text := 'Not Connected';
    bActive.BitmapSize := 48.000000000000000000;
    bActive.LargeLayoutBitmapSize := 64.000000000000000000;
    bActive.Appearance.ShowInnerStroke := False;
    bActive.Appearance.Rounding := 5.000000000000000000;
    bActive.Appearance.NormalFill.Kind := gfkSolid;
    bActive.Appearance.NormalFill.Color := clRed;
    bActive.Appearance.NormalStroke.Kind := gskNone;
    bActive.Appearance.HoverFill.Kind := gfkSolid;
    bActive.Appearance.HoverStroke.Kind := gskNone;
    bActive.Appearance.DownFill.Kind := gfkSolid;
    bActive.ControlIndex := 0;
    TMSFNCToolBarButton2.SetParentComponent(WebPanel4);
    TMSFNCToolBarButton2.Name := 'TMSFNCToolBarButton2';
    TMSFNCToolBarButton2.AlignWithMargins := True;
    TMSFNCToolBarButton2.Left := 248;
    TMSFNCToolBarButton2.Top := 8;
    TMSFNCToolBarButton2.Width := 33;
    TMSFNCToolBarButton2.Height := 26;
    TMSFNCToolBarButton2.Margins.Left := 8;
    TMSFNCToolBarButton2.Margins.Top := 8;
    TMSFNCToolBarButton2.Margins.Right := 8;
    TMSFNCToolBarButton2.Margins.Bottom := 8;
    TMSFNCToolBarButton2.Align := alRight;
    TMSFNCToolBarButton2.ParentDoubleBuffered := False;
    TMSFNCToolBarButton2.DoubleBuffered := True;
    TMSFNCToolBarButton2.Font.Charset := DEFAULT_CHARSET;
    TMSFNCToolBarButton2.Font.Color := clWindowText;
    TMSFNCToolBarButton2.Font.Height := -11;
    TMSFNCToolBarButton2.Font.Name := 'Segoe UI';
    TMSFNCToolBarButton2.Font.Style := [];
    TMSFNCToolBarButton2.ParentColor := True;
    TMSFNCToolBarButton2.TabOrder := 1;
    SetEvent(TMSFNCToolBarButton2, Self, 'OnClick', 'TMSFNCToolBarButton2Click');
    TMSFNCToolBarButton2.DropDownHeight := 270.000000000000000000;
    TMSFNCToolBarButton2.DropDownWidth := 270.000000000000000000;
    TMSFNCToolBarButton2.Text := '';
    TMSFNCToolBarButton2.BitmapSize := 48.000000000000000000;
    TMSFNCToolBarButton2.LargeLayoutBitmapSize := 64.000000000000000000;
    TMSFNCToolBarButton2.ControlIndex := 0;
    TMSFNCSplitter1.SetParentComponent(pMain);
    TMSFNCSplitter1.Name := 'TMSFNCSplitter1';
    TMSFNCSplitter1.Left := 288;
    TMSFNCSplitter1.Top := 0;
    TMSFNCSplitter1.Width := 8;
    TMSFNCSplitter1.Height := 440;
    TMSFNCSplitter1.Cursor := crHSplit;
    TMSFNCSplitter1.Margins.Left := 3;
    TMSFNCSplitter1.Margins.Top := 3;
    TMSFNCSplitter1.Margins.Right := 3;
    TMSFNCSplitter1.Margins.Bottom := 3;
    TMSFNCSplitter1.Align := alLeft;
    TMSFNCSplitter1.BevelEdges := [];
    TMSFNCSplitter1.BevelInner := bvNone;
    TMSFNCSplitter1.BevelOuter := bvNone;
    TMSFNCSplitter1.ParentDoubleBuffered := False;
    TMSFNCSplitter1.Color := 15329769;
    TMSFNCSplitter1.DoubleBuffered := True;
    TMSFNCSplitter1.TabOrder := 1;
    TMSFNCSplitter1.Appearance.IndicatorFill.Color := clBlack;
    TMSFNCSplitter1.Appearance.IndicatorStroke.Color := clWhite;
    TMSFNCSplitter1.Appearance.SplitterDownStroke.Kind := gskNone;
    TMSFNCSplitter1.Appearance.SplitterHoverStroke.Kind := gskNone;
    TMSFNCSplitter1.Appearance.SplitterStroke.Color := 15329769;
    TMSFNCSplitter1.MinSize := 40.000000000000000000;
    TMSFNCSplitter1.SplitterIndicator := siSquares;
    pnlClients.SetParentComponent(pMain);
    pnlClients.Name := 'pnlClients';
    pnlClients.Left := 296;
    pnlClients.Top := 0;
    pnlClients.Width := 344;
    pnlClients.Height := 440;
    pnlClients.Margins.Left := 3;
    pnlClients.Margins.Top := 3;
    pnlClients.Margins.Right := 3;
    pnlClients.Margins.Bottom := 3;
    pnlClients.Align := alClient;
    pnlClients.BorderColor := -1;
    pnlClients.BorderStyle := bsNone;
    pnlClients.Caption := 'pnlClients';
    pnlClients.ChildOrder := 2;
    cld.SetParentComponent(Self);
    cld.Name := 'cld';
    cld.Left := 434;
    cld.Top := 184;
    cld.Width := 200;
    cld.Height := 220;
    cld.Margins.Left := 3;
    cld.Margins.Top := 3;
    cld.Margins.Right := 3;
    cld.Margins.Bottom := 3;
    cld.ParentDoubleBuffered := False;
    cld.DoubleBuffered := True;
    cld.TabOrder := 2;
    cld.Stroke.Color := 11119017;
    cld.ItemsAppearance.Font.Charset := DEFAULT_CHARSET;
    cld.ItemsAppearance.Font.Color := 8026746;
    cld.ItemsAppearance.Font.Height := -22;
    cld.ItemsAppearance.Font.Name := 'Segoe UI';
    cld.ItemsAppearance.Font.Style := [];
    cld.ItemsAppearance.SelectedFill.Color := 16578806;
    cld.ItemsAppearance.SelectedStroke.Color := 15702829;
    cld.ItemsAppearance.SelectedStroke.Width := 2.000000000000000000;
    cld.ItemsAppearance.FixedHeight := 50.000000000000000000;
    cld.ItemsAppearance.ShowFocus := False;
    cld.DefaultItem.TextColor := 4539717;
    cld.DefaultItem.SelectedTextColor := 4539717;
    cld.Header.Text := 'Header';
    cld.Header.Fill.Color := 16380654;
    cld.Header.Font.Charset := DEFAULT_CHARSET;
    cld.Header.Font.Color := 4539717;
    cld.Header.Font.Height := -26;
    cld.Header.Font.Name := 'Segoe UI';
    cld.Header.Font.Style := [fsBold];
    cld.Header.Stroke.Kind := gskNone;
    cld.Header.Size := 72.000000000000000000;
    cld.Header.SortIndicatorColor := 11829830;
    cld.Interaction.Filtering.DropDownWidth := 200;
    cld.Interaction.Filtering.DropDownHeight := 240;
    SetEvent(cld, Self, 'OnItemClick', 'cldItemClick');
  finally
    pnlTop.AfterLoadDFMValues;
    WebButton1.AfterLoadDFMValues;
    nNewClient.AfterLoadDFMValues;
    cbAuto.AfterLoadDFMValues;
    bc.AfterLoadDFMValues;
    pMain.AfterLoadDFMValues;
    WebPanel3.AfterLoadDFMValues;
    ix.AfterLoadDFMValues;
    WebPanel4.AfterLoadDFMValues;
    bActive.AfterLoadDFMValues;
    TMSFNCToolBarButton2.AfterLoadDFMValues;
    TMSFNCSplitter1.AfterLoadDFMValues;
    pnlClients.AfterLoadDFMValues;
    cld.AfterLoadDFMValues;
  end;
end;

end.
